var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/video-time"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.3333 16.4998V27.4998C40.3333 27.9032 40.3333 28.3065 40.2966 28.6915C38.7933 26.8399 36.5016 25.6665 33.9166 25.6665C31.9733 25.6665 30.1766 26.3448 28.765 27.4815C26.8583 28.9848 25.6666 31.3132 25.6666 33.9165C25.6666 36.5015 26.8399 38.7931 28.6916 40.2965C28.3066 40.3331 27.9033 40.3332 27.5 40.3332H16.5C7.33329 40.3332 3.66663 36.6665 3.66663 27.4998V16.4998C3.66663 7.33317 7.33329 3.6665 16.5 3.6665H27.5C36.6666 3.6665 40.3333 7.33317 40.3333 16.4998Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.62 13.0352H39.38",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.62 3.86816V12.7781",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.38 3.86816V11.9532",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.1666 33.9165C42.1666 36.3915 41.0666 38.5915 39.3616 40.1132C37.895 41.3782 36.0066 42.1665 33.9166 42.1665C31.9366 42.1665 30.1033 41.4698 28.6916 40.2965C26.8399 38.7931 25.6666 36.5015 25.6666 33.9165C25.6666 31.3132 26.8583 28.9848 28.765 27.4815C30.1766 26.3448 31.9733 25.6665 33.9166 25.6665C36.5016 25.6665 38.7933 26.8399 40.2966 28.6915C41.47 30.1032 42.1666 31.9365 42.1666 33.9165Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.4299 31.3315V34.4299L31.8633 35.9698",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTime);
export default __webpack_public_path__ + "static/media/video-time.1d92f9acfb5bbc6182262bd47814d874.svg";
export { ForwardRef as ReactComponent };